<template>
  <el-dialog :visible.sync="dialogVisible" width="50%">
    <div slot="title" class="title">{{ title }}</div>

    <div class="tab-box">
		 <div class="block" v-for="(v,k) in imgUrl" :key="k">
			 <el-image
			   style="width: 200px; height: 130px"
			   :preview-src-list="imgUrl"
			   :src="v"></el-image>
	   </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // title: {
    //   type: String,
    //   default() {
    //     return "上画照片";
    //   },
    // },
  },
  data() {
    return {
		imgUrl: [],
		dialogVisible:false,
	  title:'上画照片',
	  type:0,
    };
  },
  methods: {
	handlePoint(e){
	  this.$emit('orderPoint',e)
    },
	handlePointImg(e,type){
		this.$emit('orderPointImg',{id:e,type:e,type})
	},
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-box /deep/ {
 display: flex;
 // justify-content: space-between;
 padding-bottom: 30px;
  flex-wrap: wrap;
  .el-image{
	  margin-bottom: 5px;
	  margin-right: 15px;
  }
}
/deep/ .el-dialog__body {
    padding-bottom: 0 !important;
  }
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>